import { Drawer } from '@mui/material'
import type { ReactElement } from 'react'
import useLayout from '../../../hooks/useLayout'
import { drawerPaperSx } from './styles'

interface Props {
  children: ReactElement
}

export const MobileDrawer = ({ children }: Props) => {
  const { isMobileSidebarOpen, setIsMobileSidebarOpen } = useLayout()
  return (
    <Drawer
      anchor='left'
      onClose={() => setIsMobileSidebarOpen(false)}
      open={isMobileSidebarOpen}
      PaperProps={{ sx: { ...drawerPaperSx, width: 280 } }}
      variant='temporary'
    >
      {children}
    </Drawer>
  )
}
